module.exports = __webpack_public_path__ + "static/media/ovstr.4106df24.png";